import { MaxLrAicCaseRunDetailReadModel, MaxLrCaseRunDetailReadModel, ResultLikelihoodReadModel, SentryCaseRunDetailReadModel } from "@app/api2/api";
import { buildUrl, AppRoutes } from "@app/components/React/AppRoutes";
import { BPBoxWithHeader } from "@app/components/React/Common/BPBoxWithHeader";
import { InfoBox } from "@app/components/React/Common/InfoBox";
import { anyToDecimal, toSci, toSciDecimal } from "@app/components/React/Common/Utils";
import Decimal from "decimal.js";
import React from "react";
import { Link } from "react-router-dom";

interface IWeightOfEvidenceBoxProps {
    model: MaxLrCaseRunDetailReadModel | MaxLrAicCaseRunDetailReadModel | SentryCaseRunDetailReadModel;
    forPrint?: boolean;
}

export const WeightOfEvidenceBox: React.FunctionComponent<IWeightOfEvidenceBoxProps> = (props) => {
    const getOrder = (likelihoodType) => {
        return likelihoodType == 'maximum' ? 1 : likelihoodType == 'bayes_unrestricted' ? 2 : 3;
    }
    const nca = props.model?.results && 'calculationResponses' in props.model?.results && props.model?.results['calculationResponses'].sort((x, y) => y.calculationId - x.calculationId).map(x => x.nonContrResult).find(x => x != null);
    // const getLoglikAndLik = (m: ResultLikelihoodReadModel)=> {
    //     if (m.likelihoodType == )
    // };
    return <>
        <BPBoxWithHeader forPrint={props.forPrint} header={window.translation.caseRunView.weightOfEvidence}>
            {props.model?.results?.likelihoods?.map(m => (
                <InfoBox forPrint={props.forPrint} compact key={m.likelihoodType} header={m.calculationId == null ? window.translation.likelihoodType[m.likelihoodType] : <Link to={buildUrl(AppRoutes.CaseRunCalculationDetails, { calculationId: m.calculationId, caseId: props.model.efmCaseId, labId: props.model.labId, caseRunId: props.model.caseRunId })}>{window.translation.likelihoodType[m.likelihoodType]}</Link>} items={[
                    {
                        width: 10, label: window.translation.caseRunView.likelihoodRatio, description: <span>
                            {toSciDecimal(anyToDecimal(m.likelihoodRatioStr))}
                            {/* <br></br>{toSciDecimal(anyToDecimal(m.likelihoodRatio))} */}
                        </span>
                    },
                    {
                        width: 10, label: <span dangerouslySetInnerHTML={{ __html: window.translation.caseRunView.likelihoodRatioLog10 }} />, description: <span>
                            {toSciDecimal((anyToDecimal(m.likelihoodRatioLog10Str)))}
                            {/* <br />{toSciDecimal((anyToDecimal(m.likelihoodRatioLog10)))} */}
                        </span>
                    }
                ]}></InfoBox>
            ))}
            {nca &&
                <InfoBox forPrint={props.forPrint} compact header={window.translation.caseRunView.ncAnalysis} items={[
                    { width: 10, label: window.translation.caseRunView.ncAnalysisMax, description: toSci(nca.max, 4) },
                    { width: 10, label: <span dangerouslySetInnerHTML={{ __html: window.translation.caseRunView.ncAnalysisMeanLR }} />, description: toSci(nca.meanLR, 2) }
                ]}></InfoBox>}
        </BPBoxWithHeader>

    </>;
};
